import fetchIntercept from 'fetch-intercept';

const xsrfToken = 'x-xsrf-token';
const HttpInterceptor = () => {
    fetchIntercept.register({
        request (url, config) {
            // Add the CSRF token for non-GET/HEAD/OPTIONS/TRACE requests
            if (config && 'method' in config && !['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(config['method'])) {
                // This seems to be getting called many times for each request, make sure we haven't added CSRF already
                if (config.headers) {
                    const csrfToken = sessionStorage.getItem('csrf_token');
                    // The type of the 'config' variable is sometimes a bespoke class, sometimes a dictionary.
                    // Handle both cases.
                    if('has' in config.headers && !(config.headers.has(xsrfToken))) {
                        config.headers.append(xsrfToken, csrfToken);
                    } else {
                        config.headers[xsrfToken] = csrfToken;
                    }
                }
            }
            return [url, config];
        },

        requestError (error) {
            // Called when an error occured during another 'request' interceptor call
            return Promise.reject(error);
        },

        response (response) {
            // Modify the reponse object
            if (response.redirected) {
                // Server issued a redirect (e.g. SAML IdP). Save current path so
                // App.jsx can restore it after re-authentication.
                // JSON.stringify to match useLocalStorage's format.
                localStorage.setItem('redirectUrl', JSON.stringify(window.location.pathname));
                window.location.href = response.url;
            } else if (response.status === 401) {
                // Server returned 401 for a background AJAX call (session expired).
                // Redirect to SAML IdP explicitly to avoid a cross-origin redirect
                // which would cause a CORS error.
                localStorage.setItem('redirectUrl', JSON.stringify(window.location.pathname));
                window.location.href = '/user/saml2/authenticate/SSO';
            }

            return response;
        },

        responseError (error) {
            // Handle an fetch error
            return Promise.reject(error);
        },
    });
};

export default HttpInterceptor
